import { Icon, IconButton, Stack, Tooltip } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useFormContext } from "react-hook-form"

type Props = {
    isSaving?: boolean
    onCloseButtonClick(): void
}

export function EditDialogHeaderButtons({ isSaving, onCloseButtonClick }: Props) {
    const { translateText } = useLocalization()
    const { formState, reset } = useFormContext()
    const { isDirty } = formState

    return (
        <Stack direction="row" gap={0.5}>
            <Tooltip title={translateText(48)}>
                {/* since reset expects values as paramters, we must ensure none are given to it () => reset() */}
                <IconButton variant="contained" size="extralarge" onClick={() => reset()} disabled={!isDirty || isSaving}>
                    <Icon name="refresh" />
                </IconButton>
            </Tooltip>
            <Tooltip title={translateText(70)}>
                <IconButton variant="contained" size="extralarge" onClick={onCloseButtonClick} disabled={isSaving}>
                    <Icon name="close" />
                </IconButton>
            </Tooltip>
            <Tooltip title={translateText(9)}>
                <IconButton type="submit" variant="contained" size="extralarge" color="success" disabled={!isDirty || isSaving}>
                    <Icon name="check" />
                </IconButton>
            </Tooltip>
        </Stack>
    )
}
